export const API_URL = 'https://localhost:3300'
export const SERVER_PORT = 3300

export const ROW_PER_PAGE = 5
export const DOMAIN = 'http://fing.edu.uy'
export const BASE_NAME = '/inco/grupos/gema'

export const HOME_ROUTE = `${BASE_NAME}`
export const RESEARCH_LINES = `${BASE_NAME}/research-lines`
export const RESEARCH_PROJECTS = `${BASE_NAME}/research-projects`
export const PROYGRADO = `${BASE_NAME}/undergrad-projects`
export const PROYPOS = `${BASE_NAME}/msc-projects`
export const COURSES = `${BASE_NAME}/courses`
export const RESEARCH_PAPERS = `${BASE_NAME}/research-papers`